import _DatabaseModel from "./_DatabaseModel";

const EXTERNAL_EMAILS_TAB_ISSUES = 54;

class ExternalEmail extends _DatabaseModel {
  static model = "external_email";
  static editDialogComponent = "external-email-edit-dialog";
  static createNewObject = false;

  static tableHeaders = [
    { textKey: "form.label.email", value: "email" },
    { textKey: "profile.locale", value: "locale" },
  ];

  static show = {
    buttons: ["edit"],
    reloadingModels: [],
  };

  static filter = {
    parts: {
      fields: ["email", "time_filter"],
      extended_fields: [],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static cardFields(object) {
    return {
      title: object.email,
    };
  }

  static basicInfo(object) {
    return [
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
    ];
  }

  static submenuActions = [this.commonActions.openActivities];

  static tabs = [
    {
      titleKey: "issue.issues",
      permission: EXTERNAL_EMAILS_TAB_ISSUES,
      component: "IssuesTab",
      disabled: () => false,
    },
  ];
}

export default ExternalEmail;
